import React, { useEffect, useMemo } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setPlantingQueueInputs } from '../../../actions/load';
import { getPlantingQueueSessionInputs, setPlantingQueueSessionInputs } from '../../../helpers/session';

const LoadQueueBulkEdit = (props) => {
	const dispatch = useDispatch();
	const selectedLoadIds = useSelector((state) => state.load.selectedLoadIds);
	const scaleSocket = useSelector(state => state.scaleSocket);
	const isNeedPlanterValues = useSelector(state => state.load.isNeedPlanterValues);
	const { fieldRegionOptions, sourceEGOptions, plantingQueueInputs, setSessionOptions, isPlanterAllocation } = props;
	let { fieldShapeId, planterId, loadCapacity } = plantingQueueInputs;
	let sessionInputs = getPlantingQueueSessionInputs();

	useEffect(() => {
		if (sessionInputs) {
			const { fieldShapeId, planterId, loadCapacity, fieldRegionId } = sessionInputs;
			dispatch(setPlantingQueueInputs({
				fieldShapeId,
				planterId,
				loadCapacity,
				fieldRegionId
			}))
		}
	}, [])

	const { socketConneted } = useMemo(() => {
		const { isConnected } = scaleSocket;
		return { socketConneted: isConnected }
	}, [scaleSocket]);

	const isMarkAsComplete = useMemo(() => {
		if (selectedLoadIds && selectedLoadIds.length > 0) {
			if (isNeedPlanterValues) return false;
			return true;
		}
		return false;
	}, [isNeedPlanterValues, selectedLoadIds])


	return (
		(!socketConneted && isPlanterAllocation) ? <div className="col-12 my-2 p-0 mx-0 pl-2">
			<Row className={`m-0 bulk-edit-container mr-2 ${isMarkAsComplete ? 'opacity-none' : ''}`}>
				<Col
					style={{
						width: "220px",
						marginLeft: "-11px",
					}}
					className="p-0 pr-1">
					<Form.Select
						value={fieldShapeId || 'N/A'}
						placeholder="Field Site"
						options={fieldRegionOptions}
						onChange={(e) => {
							const value = e ? e.value : null
							const regionId = e ? e.regionId : null
							if (value) {
								setSessionOptions("fieldRegionSessionOptions", value)
							}
							let data = getPlantingQueueSessionInputs();
							setPlantingQueueSessionInputs({ ...data, "fieldShapeId": value, "fieldRegionId": regionId })
							dispatch(setPlantingQueueInputs({
								fieldShapeId: value,
								fieldRegionId: regionId
							}))
						}}
						sortType="asc"
					/>
				</Col>
				<Col style={{ width: "165px", }}
					className="p-0">
					<Form.Select
						value={planterId || 'N/A'}
						placeholder="Planter"
						options={sourceEGOptions}
						onChange={e => {
							const value = e ? e.value : null
							if (value) {
								setSessionOptions("sourceEGSessionOptions", value)
							}
							let data = getPlantingQueueSessionInputs() || {};
							data['planterId'] = value;
							setPlantingQueueSessionInputs(data)
							dispatch(setPlantingQueueInputs({
								planterId: value,
							}))
						}}
						sortType="asc"
					/>
				</Col>
				<Col
					style={{
						width: "135px",
						marginLeft: "4px",
					}}
					className="p-0 pr-1">
					<Form.Control
						type="number"
						placeholder="Capacity"
						className=''
						value={loadCapacity || "N/A"}
						// disabled={selectedLoadIds && selectedLoadIds.length === 0}
						style={{ height: '38px', fontSize: '14px' }}
						onChange={e => {
							const value = e.target.value;
							let data = getPlantingQueueSessionInputs() || {};
							data['loadCapacity'] = Number(value);
							setPlantingQueueSessionInputs(data)
							dispatch(setPlantingQueueInputs({
								loadCapacity: Number(value)
							}))
						}}
					/>
				</Col>
			</Row>
		</div> : null
	);
};
export default (LoadQueueBulkEdit);